import { createContext } from 'react';
interface ContentSignatureContext {
  contentSignature: string;
  contentSignatureError?: string;
  contentSignatureLoading: boolean;
};

export default createContext<ContentSignatureContext>({
  contentSignature: '',
  contentSignatureLoading: true,
});
